(() => {
  const theme = window.RespireTheme || {};
  const status = document.getElementById('ThemeStatus');
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {
    style: 'currency',
    currency: theme.currency || 'EUR'
  }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  })[character]);

  const searchPageInput = document.querySelector('.search-page-form input[name="q"]');
  if (searchPageInput) {
    const normalizedTerms = searchPageInput.value.trim().toLowerCase();
    const isNewProductsQuery = normalizedTerms.includes('tag:new')
      && normalizedTerms.includes('not')
      && normalizedTerms.includes('new-roll-on');
    if (isNewProductsQuery) {
      const searchSection = searchPageInput.closest('.main-search');
      searchSection?.classList.add('main-search--category', 'main-search--new-products');
      const heading = searchSection?.querySelector('.page-header h1');
      if (heading) heading.textContent = 'Nouveautés';
      searchPageInput.closest('.search-page-form')?.remove();
      searchSection?.querySelector('.search-count')?.remove();
    }
  }

  const closeDialog = (dialog) => {
    if (dialog && dialog.open) dialog.close();
  };

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const closeMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    document.body.classList.remove('mobile-menu-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileMenuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.querySelectorAll('[data-mobile-accordion]').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-mobile-accordion-toggle]').setAttribute('aria-expanded', 'false');
    });
  };
  const openMobileMenu = () => {
    if (!mobileMenu || !mobileMenuToggle) return;
    document.body.classList.add('mobile-menu-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileMenuToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.scrollTop = 0;
  };
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', () => {
      if (document.body.classList.contains('mobile-menu-open')) closeMobileMenu();
      else openMobileMenu();
    });
  }
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMobileMenu));
    mobileMenu.querySelectorAll('[data-mobile-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const accordion = toggle.closest('[data-mobile-accordion]');
        const willOpen = !accordion.classList.contains('is-open');
        mobileMenu.querySelectorAll('[data-mobile-accordion]').forEach((item) => {
          item.classList.remove('is-open');
          item.querySelector('[data-mobile-accordion-toggle]').setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          accordion.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      closeMobileMenu();
      const dialog = document.getElementById(opener.dataset.dialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        const focusTarget = dialog.id === 'SearchDialog'
          ? dialog.querySelector('[data-predictive-input]')
          : dialog.querySelector('input:not([type="hidden"]), button, a');
        if (focusTarget) focusTarget.focus();
        if (dialog.id === 'CartDrawer') refreshCart();
      }
      return;
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) closeDialog(closer.closest('dialog'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMobileMenu();
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) closeMobileMenu();
  }, { passive: true });

  document.querySelectorAll('dialog').forEach((dialog) => {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog(dialog);
    });
  });

  const predictiveInput = document.querySelector('[data-predictive-input]');
  const predictiveResults = document.querySelector('[data-predictive-results]');
  let predictiveTimer;
  if (predictiveInput && predictiveResults) {
    predictiveInput.addEventListener('input', () => {
      window.clearTimeout(predictiveTimer);
      const query = predictiveInput.value.trim();
      if (query.length < 2) {
        predictiveResults.innerHTML = '';
        predictiveInput.setAttribute('aria-expanded', 'false');
        return;
      }
      predictiveTimer = window.setTimeout(async () => {
        try {
          const url = `${theme.routes.predictiveSearch}?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=4&section_id=predictive-search`;
          const response = await fetch(url);
          if (!response.ok) throw new Error('search');
          predictiveResults.innerHTML = await response.text();
          predictiveInput.setAttribute('aria-expanded', 'true');
        } catch (_error) {
          predictiveResults.innerHTML = '';
        }
      }, 220);
    });
  }

  const cartDrawer = document.getElementById('CartDrawer');
  const cartContent = document.querySelector('[data-cart-drawer-content]');
  const renderShippingProgress = (totalPrice) => {
    const threshold = Number(theme.shippingThreshold || 5000);
    const remaining = Math.max(threshold - Number(totalPrice || 0), 0);
    const progress = threshold > 0 ? Math.min((Number(totalPrice || 0) / threshold) * 100, 100) : 100;
    const message = remaining > 0
      ? `Plus que <strong>${formatMoney(remaining)}</strong> pour profiter de la livraison offerte.`
      : 'Livraison offerte activée !';
    return `<div class="shipping-progress" aria-live="polite"><p>${message}</p><div class="shipping-progress__track" role="progressbar" aria-label="Progression vers la livraison offerte" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(progress)}"><span style="width:${progress}%"></span></div></div>`;
  };
  const renderCart = (cart) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; });
    if (!cartContent) return;
    if (!cart.item_count) {
      cartContent.innerHTML = `<div class="cart-drawer__empty"><div><p>Votre panier est vide</p><a class="button" href="${theme.routes.allProducts || `${theme.routes.root}collections/all`}">Découvrir nos soins</a></div></div>`;
      return;
    }
    const lines = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}&width=240" alt="${escapeHtml(item.product_title)}" width="120" height="150">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<small>${escapeHtml(item.variant_title)}</small>` : '';
      return `<article class="cart-drawer__item">
        <a href="${escapeHtml(item.url)}">${image}</a>
        <div class="cart-drawer__item-info"><a href="${escapeHtml(item.url)}"><strong>${escapeHtml(item.product_title)}</strong></a>${variant}<span>${item.quantity} × ${formatMoney(item.final_price)}</span></div>
        <strong>${formatMoney(item.final_line_price)}</strong>
      </article>`;
    }).join('');
    cartContent.innerHTML = `${lines}<div class="cart-drawer__footer">${renderShippingProgress(cart.total_price)}<div class="cart-drawer__total"><span>Total</span><strong>${formatMoney(cart.total_price)}</strong></div><div class="cart-drawer__actions"><a class="button button--outline" href="${theme.routes.cart}">Voir le panier</a><a class="button" href="${theme.routes.checkout}">Commander</a></div></div>`;
  };
  const refreshCart = async () => {
    try {
      const response = await fetch(`${theme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart');
      renderCart(await response.json());
    } catch (_error) {
      if (cartContent) cartContent.innerHTML = '<p>Le panier ne peut pas être chargé pour le moment.</p>';
    }
  };

  document.querySelectorAll('.js-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const error = form.querySelector('[data-product-error]');
      if (submit) submit.disabled = true;
      if (error) error.hidden = true;
      try {
        const response = await fetch(`${theme.routes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || 'Impossible d’ajouter ce produit.');
        await refreshCart();
        if (cartDrawer && typeof cartDrawer.showModal === 'function' && !cartDrawer.open) cartDrawer.showModal();
        if (status) status.textContent = `${payload.product_title || 'Produit'} ajouté au panier`;
      } catch (caught) {
        if (error) {
          error.textContent = caught.message;
          error.hidden = false;
        } else if (status) status.textContent = caught.message;
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-gallery-track]');
    const setActive = (mediaId) => {
      if (!mediaId) return;
      gallery.querySelectorAll('.product-gallery__item[data-media-id]').forEach((item) => item.classList.toggle('is-active', item.dataset.mediaId === String(mediaId)));
      gallery.querySelectorAll('[data-media-target]').forEach((button) => {
        const active = button.dataset.mediaTarget === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };
    const showMedia = (mediaId) => {
      const item = gallery.querySelector(`.product-gallery__item[data-media-id="${mediaId}"]`);
      if (!item) return;
      setActive(mediaId);
      if (window.matchMedia('(max-width: 989px)').matches && track) {
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
    };
    gallery.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    if (track) {
      let galleryFrame;
      track.addEventListener('scroll', () => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        window.cancelAnimationFrame(galleryFrame);
        galleryFrame = window.requestAnimationFrame(() => {
          const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          const item = track.querySelectorAll('.product-gallery__item')[index];
          if (item) setActive(item.dataset.mediaId);
        });
      }, { passive: true });
    }
    const section = gallery.closest('[data-product-section]');
    const variantSelect = section ? section.querySelector('[data-variant-select]') : null;
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        const mediaId = option.dataset.mediaId;
        if (mediaId) showMedia(mediaId);
        const price = Number(option.dataset.price || 0);
        section.querySelectorAll('[data-current-price], [data-submit-price]').forEach((node) => { node.textContent = formatMoney(price); });
      });
    }
  });

  document.querySelectorAll('[data-auto-submit]').forEach((select) => select.addEventListener('change', () => select.form.submit()));

  document.querySelectorAll('.care-finder__form').forEach((form) => {
    form.addEventListener('submit', () => {
      const main = form.querySelector('[name="q"]');
      const extra = Array.from(form.querySelectorAll('[data-query-part]')).map((input) => input.value).filter(Boolean);
      if (main) main.value = [main.value, ...extra].join(' ');
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    if (section.innerHTML.trim()) return;
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      const replacement = html.querySelector('[data-product-recommendations]');
      if (replacement && replacement.innerHTML.trim()) {
        section.innerHTML = replacement.innerHTML;
        const reviews = document.querySelector('[data-product-reviews]');
        const faq = document.querySelector('.respire-product-faq');
        if (reviews && reviews.isConnected) reviews.after(section);
        else if (faq) faq.before(section);
      }
    } catch (_error) {
      // Recommendations are optional and stay hidden when unavailable.
    }
  });

  document.querySelectorAll('[data-service-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-service-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-service-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-service-dot]'));
    if (!track || slides.length < 2) return;
    let index = 0;
    let timer;
    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(${-index * 100}%,0,0)`;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === index));
      dots.forEach((dot, position) => {
        const active = position === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(() => show(index + 1), 4000);
      }
    };
    dots.forEach((dot, position) => dot.addEventListener('click', () => { show(position); start(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);
    show(0);
    start();
  });

  const recentRoot = document.querySelector('[data-recently-viewed]');
  const currentProductScript = document.querySelector('[data-current-product-summary]');
  if (recentRoot && currentProductScript) {
    try {
      const current = JSON.parse(currentProductScript.textContent);
      const storageKey = 'respire_recently_viewed_v1';
      let history = [];
      try { history = JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch (_error) { history = []; }
      history = [current, ...history.filter((item) => item && item.handle !== current.handle)].slice(0, 8);
      try { window.localStorage.setItem(storageKey, JSON.stringify(history)); } catch (_error) { /* Storage can be disabled. */ }
      const track = recentRoot.querySelector('[data-recently-viewed-track]');
      if (track) {
        track.innerHTML = history.map((item) => `<a class="recently-viewed__card" href="${escapeHtml(item.url)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="900" height="1125" loading="lazy">` : ''}
          <strong>${escapeHtml(item.title)}</strong><span>${escapeHtml(item.priceFormatted || formatMoney(item.price))}</span>
        </a>`).join('');
      }
    } catch (_error) {
      recentRoot.hidden = true;
    }
  }

  const parallaxMedia = document.querySelector('[data-parallax-media]');
  if (parallaxMedia && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    let parallaxFrame;
    const updateParallax = () => {
      const top = Math.max(window.scrollY, 0);
      parallaxMedia.style.transform = `translate3d(0, ${Math.min(top * -0.035, 0)}px, 0) scale(${1 + Math.min(top / 20000, 0.028)})`;
      parallaxFrame = null;
    };
    window.addEventListener('scroll', () => {
      if (!parallaxFrame) parallaxFrame = window.requestAnimationFrame(updateParallax);
    }, { passive: true });
  }

  document.documentElement.dataset.respireThemeReady = 'true';

})();
